export default __webpack_public_path__ + "src/images/number_region-1e2f49.png";